import { Controller } from "stimulus";

// This controller is used in combination with the #terminate_modal function
// to re-enable the scrollbar after a modal has been closed
export default class extends Controller {
  disconnect(): void {
    document.body.style.overflow = "auto";
  }
}
